// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2POhB","question":"Question_question__5PTWd","description":"Question_description__3-dzb"};